<template>
    <div class="d-flex flex-row gap-3">
        <div v-if="productable.imageUrl">
            <img :src="productable.imageUrl" :alt="productable.id" class="h-3em rounded">
        </div>
        <div class="d-flex flex-column">
            <div>
                <div :class="{'font-weight-bold font-size-lg': !plain}">
                    {{ getTranslation(productable.lang.name) || __('general.thing.unknown', {thing:__('general.produkt')}) }}
                </div>
                <div v-if="!plain" class="font-weight-light line-height-sm">
                    {{ getTranslation(productable.lang.description) || 'No description available.' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helperMethods from '@mixins/helperMethods'

export default {
    mixins: [helperMethods],

    props: {
        productable: Object,
        plain: Boolean
    },
}
</script>
